import { DateTime } from "luxon";
import { v4 as randomUuid } from "uuid";
import { type CreateCalendarEventDto, serverAPI } from "../../api/server.api";
import { assertValid } from "../../backoffice.utils";
import { VehicleEventForm, type VehicleEventFormValues } from "../../misc/calendar/VehicleEventForm";
import { VehicleEventTypeEnum } from "../../model/autovioCalendarEvents";

export function CreateVehicleEventForm(props: {
  vehicleId: string;
  initialDateTime?: DateTime;
  onSuccess: () => void;
}) {
  const { vehicleId: initialVehicleId, initialDateTime, onSuccess } = props;

  const onSubmit = async (formValues: VehicleEventFormValues) =>
    runSafely(
      async () => {
        const { start, end, vehicleId, vehicleEventType, noteForInstructor } = formValues;
        if (vehicleId === null) {
          throw new Error("Fahrzeug muss ausgewählt werden.");
        }
        const vehicleEventType_ = VehicleEventTypeEnum.parse(vehicleEventType);
        const start_ = assertValid(start, "start");
        const dto: CreateCalendarEventDto = {
          type: "VehicleEvent" as const,
          id: randomUuid(),
          vehicleId,
          start: start_.toISO(),
          end: assertValid(end, "end")
            .set({
              year: start_.year,
              month: start_.month,
              day: start_.day,
            })
            .toISO(),
          vehicleEventType: vehicleEventType_,
          noteForInstructor: noteForInstructor ?? undefined,
        };
        await serverAPI.createCalendarEvent(dto);
      },
      {
        errorMessage: "Fehler beim Anlegen des Termins.",
        successMessage: "Termin erfolgreich angelegt.",
        onSuccess,
      },
    );

  return <VehicleEventForm initialDateTime={initialDateTime} vehicleId={initialVehicleId} onSubmit={onSubmit} />;
}
